export var NSMessages = {

	private_objs: {
		e_div_cgi_urlreq_error: null,
		e_div_cgi_urlreq_error_message: null,
		e_div_cgi_urlreq_information: null,
		e_div_cgi_urlreq_information_message: null,
		e_div_cgi_urlreq_success: null,
		e_div_cgi_urlreq_success_message: null,
		
		o_timeout_error_id: null,
		o_timeout_information_id: null,
		o_timeout_success_id: null,
		
		f_close_callback_error: null,
		f_close_callback_information: null,
		f_close_callback_success: null,

		s_close_button_image_src: null
		
	},

	/*
	o_in: {
		s_close_button_image_src
	}
	*/
	init: function(o_in)
	{
		this.f_init_style();
		
		this.private_objs.s_close_button_image_src = o_in.s_close_button_image_src;

		this.o_error.f_init_error_div();
		this.o_information.f_init_information_div();
		this.o_success.f_init_success_div();

		window.NSMessages_ = NSMessages;
	},
	
	f_init_style: function()
	{
		
		/*
		 	opacity: 0.7;
			width: 12px;		-> image is 18px resizing to a smaller size
    		height: 12px;		-> image is 18px resizing to a smaller size
		*/

		/*
			
			INCLUIR messages.css




		var s_close_burron_hover_css = '.messages_close_button{ opacity: 0.7; width: 12px; height: 12px;}';
		s_close_burron_hover_css += '\r\n.messages_close_button:hover{ opacity: 1.0; cursor: pointer; }';
		
		//message default style:
		var s_messages_div_main_default_css = '\
			.messages_div_main_default_error {\
				position: absolute;\
				left: calc(50% - 330px);\
				width: 660px;\
				height: 108px;\
				top: 150px;\
				z-index: 1500;\
				\
				color: #222222;\
				background-color: rgb(251 241 243);\
				opacity: 0.96;\
				border: 1px solid #D0151C;\
				border-radius: 3px;\
				\
				\
				padding-top: 22px;\
				padding-bottom: 0px;\
				padding-left: 16px;\
				padding-right: 0px;\
				margin-bottom: 19px;\
			}\
			.messages_div_main_default_information {\
				position: absolute;\
				left: calc(50% - 330px);\
				width: 660px;\
				height: 108px;\
				top: 150px;\
				z-index: 1500;\
				\
				color: #222222;\
				background-color: #EEEEFF;\
				opacity: 0.96;\
				border: 1px solid #005A8B;\
				border-radius: 3px;\
				\
				\
				padding-top: 22px;\
				padding-bottom: 0px;\
				padding-left: 16px;\
				padding-right: 0px;\
				margin-bottom: 19px;\
			}\
			.messages_div_main_default_success {\
				position: absolute;\
				left: calc(50% - 330px);\
				width: 660px;\
				height: 108px;\
				top: 150px;\
				z-index: 1500;\
				\
				color: #222222;\
				background-color: #F0F9FF;\
				opacity: 0.96;\
				border: 1px solid #005A8B;\
				border-radius: 3px;\
				\
				\
				padding-top: 22px;\
				padding-bottom: 0px;\
				padding-left: 16px;\
				padding-right: 0px;\
				margin-bottom: 19px;\
			}';
		
		var s_complete_css = s_close_burron_hover_css + s_messages_div_main_default_css;
		
		var style = document.createElement('style');
		if (style.styleSheet) {
			style.styleSheet.cssText = s_complete_css;
		} else {
			style.appendChild(document.createTextNode(s_complete_css));
		}

		document.getElementsByTagName('head')[0].appendChild(style);
		
		*/
		
		
		
	},
	
	f_show_error:  function (s_msg, i_time_out)
	{
		let o_in = {
			s_msg: s_msg,
			i_time_out: i_time_out,
			f_callback: null,
			o_style: null
		};

		this.o_error.f_show_error(o_in);
	},

	f_hide_error: function ()
	{
		this.o_error.f_hide_error();
	},
	
	f_show_information:  function (s_msg, i_time_out)
	{
		let o_in = {
				s_msg: s_msg,
				i_time_out: i_time_out,
				f_callback: null,
				o_style: null
			};

		this.o_information.f_show_information(o_in);
	},

	f_hide_information:  function ()
	{
		this.o_information.f_hide_information();
	},
	
	f_show_success: function (s_msg, i_time_out)
	{
		let o_in = {
			s_msg: s_msg,
			i_time_out: i_time_out,
			f_callback: null,
			o_style: null
		};

		this.o_success.f_show_success(o_in);
	},

	f_hide_success:  function ()
	{
		this.o_success.f_hide_success();
	},



	o_error: 
	{
		f_init_error_div: function ()
		{
			var private_objs = NSMessages.private_objs;
			var this_ = this;
			
		
			var e_div_cgi_urlreq_error = document.createElement("div");
			e_div_cgi_urlreq_error.setAttribute("id", "div_cgi_urlreq_error");
			
			e_div_cgi_urlreq_error.classList.add("message_container", "error");
			
			/*
			e_div_cgi_urlreq_error.setAttribute("style", 'position: absolute;\
												left: calc(50% - 330px);\
												width: 660px;\
												height: 108px;\
												top: 150px;\
												z-index: 1000;\
												\
												color: #222222;\
												background-color: rgb(251 241 243);\
												opacity: 0.96;\
												border: 1px solid #D0151C;\
												border-radius: 3px;\
												\
												\
												padding-top: 22px;\
												padding-bottom: 0px;\
												padding-left: 16px;\
												padding-right: 0px;\
												margin-bottom: 19px;');
			*/
												
				
			
			
			var e_div_cgi_urlreq_error_button_close = document.createElement("img");
			
			e_div_cgi_urlreq_error_button_close.setAttribute("id", "div_cgi_urlreq_error_button_close");
			e_div_cgi_urlreq_error_button_close.setAttribute("alt", "X");
			e_div_cgi_urlreq_error_button_close.setAttribute("src", private_objs.s_close_button_image_src );

			e_div_cgi_urlreq_error_button_close.setAttribute("class", "messages_close_button");
			
			
			e_div_cgi_urlreq_error_button_close.onclick = function()
			{	
				clearTimeout(private_objs.o_timeout_error_id);
				this_.f_hide_error();

				var f_close_callback_error = private_objs.f_close_callback_error;
				if(f_close_callback_error != null)
				{
					private_objs.f_close_callback_error = null;
					f_close_callback_error();
				}
			}
			
			
			var e_div_cgi_urlreq_error_message = document.createElement("div");
			e_div_cgi_urlreq_error_message.setAttribute("id", "div_cgi_urlreq_error_message");
			
			e_div_cgi_urlreq_error.appendChild(e_div_cgi_urlreq_error_message);
			e_div_cgi_urlreq_error.appendChild(e_div_cgi_urlreq_error_button_close);
			
			private_objs.e_div_cgi_urlreq_error = e_div_cgi_urlreq_error;
			private_objs.e_div_cgi_urlreq_error_message = e_div_cgi_urlreq_error_message;
			
			this.f_hide_error();
			document.body.appendChild(e_div_cgi_urlreq_error);
		},
		
		/*
			var o_style = {
				height: "200px",
				width: "900px",
				"padding-top": "100px",
				"padding-left": "50px"
			}
			var o_in = {
				s_msg: s_msg,
				i_time_out: 750000,
				f_callback: null,
				// o_style: o_style -> Descontinuado devido a content_security_policy sem tolerância a inline execution / CSS inline
			};
		*/
		f_show_error: function(o_in)
		{
			var this_ = this;
			var private_objs = NSMessages.private_objs;
			var e_div_cgi_urlreq_error = private_objs.e_div_cgi_urlreq_error;
			
			var s_msg = o_in.s_msg;
			var i_time_out = o_in.i_time_out;
			var f_callback = o_in.f_callback;
			private_objs.f_close_callback_error = f_callback;
			
			/*
				 -> Descontinuado devido a content_security_policy sem tolerância a inline execution / CSS inline

			var o_style = o_in.o_style;

			if(o_style != null)
			{
				var s_style = "";
				var a_keys = Object.keys(o_style);
				for(var i=0; i<a_keys.length; i++)
				{
					var s_key_i = a_keys[i];
					var s_val_i = o_style[s_key_i];
					
					s_style += " " + s_key_i + ": " + s_val_i + ";";
					
					if(s_key_i.toLowerCase() == "width")
					{
						var i_width = parseInt(s_val_i);
						var i_half = parseInt(i_width/2)
						s_style += " left: calc(50% - " + i_half + "px);";
					}
				}

				e_div_cgi_urlreq_error.setAttribute("style", s_style);
				
			}
			*/
			
			var s_ = (s_msg != null)? s_msg : "";
			var i_time_out_ = (i_time_out != null)? i_time_out : 7500;
			
			var e_div_cgi_urlreq_error_message = private_objs.e_div_cgi_urlreq_error_message;
			e_div_cgi_urlreq_error_message.innerHTML = s_;
			e_div_cgi_urlreq_error.style.display = "inline"; //null;
			
			clearTimeout(private_objs.o_timeout_error_id);
			private_objs.o_timeout_error_id = setTimeout(function(){
				this_.f_hide_error();
				
				if(f_callback != null)
				{
					private_objs.f_close_callback_error = null;
					f_callback();
				}
			},i_time_out_);
			
		},
		f_hide_error: function()
		{
			var private_objs = NSMessages.private_objs;
			
			var e_div_cgi_urlreq_error = private_objs.e_div_cgi_urlreq_error;
			e_div_cgi_urlreq_error.style.display = "none";
		}
	
	},
	
	o_information: 
	{
		f_init_information_div: function ()
		{
			var private_objs = NSMessages.private_objs;
			var this_ = this;
			
		
			var e_div_cgi_urlreq_information = document.createElement("div");
			e_div_cgi_urlreq_information.setAttribute("id", "div_cgi_urlreq_information");
			
			e_div_cgi_urlreq_information.classList.add("message_container", "information");
			
			/*
			e_div_cgi_urlreq_information.setAttribute("style", 'position: absolute;\
												left: calc(50% - 330px);\
												width: 660px;\
												height: 108px;\
												top: 150px;\
												z-index: 1000;\
												\
												color: #222222;\
												background-color: #AAAAFF;\
												opacity: 0.96;\
												border: 1px solid #005A8B;\
												border-radius: 3px;\
												\
												\
												padding-top: 22px;\
												padding-bottom: 0px;\
												padding-left: 16px;\
												padding-right: 0px;\
												margin-bottom: 19px;\";');
			*/
												
				
			
			
			var e_div_cgi_urlreq_information_button_close = document.createElement("img");
			
			e_div_cgi_urlreq_information_button_close.setAttribute("id", "div_cgi_urlreq_information_button_close");
			e_div_cgi_urlreq_information_button_close.setAttribute("alt", "X");
			e_div_cgi_urlreq_information_button_close.setAttribute("src", private_objs.s_close_button_image_src);
			e_div_cgi_urlreq_information_button_close.setAttribute("class", "messages_close_button");
			
			
			e_div_cgi_urlreq_information_button_close.onclick = function()
			{
				clearTimeout(private_objs.o_timeout_information_id);
				this_.f_hide_information();
				
				var f_close_callback_information = private_objs.f_close_callback_information;
				if(f_close_callback_information != null)
				{
					private_objs.f_close_callback_information = null;
					f_close_callback_information();
				}
			}
			
			
			var e_div_cgi_urlreq_information_message = document.createElement("div");
			e_div_cgi_urlreq_information_message.setAttribute("id", "div_cgi_urlreq_information_message");
			
			e_div_cgi_urlreq_information.appendChild(e_div_cgi_urlreq_information_message);
			e_div_cgi_urlreq_information.appendChild(e_div_cgi_urlreq_information_button_close);
			
			private_objs.e_div_cgi_urlreq_information = e_div_cgi_urlreq_information;
			private_objs.e_div_cgi_urlreq_information_message = e_div_cgi_urlreq_information_message;
			
			this.f_hide_information();
			document.body.appendChild(e_div_cgi_urlreq_information);
		},
		
		/*
			var o_style = {
				height: "200px",
				width: "900px",
				"padding-top": "100px",
				"padding-left": "50px"
			}
			var o_in = {
				s_msg: s_msg,
				i_time_out: 750000,
				f_callback: null,
				// o_style: o_style -> Descontinuado devido a content_security_policy sem tolerância a inline execution / CSS inline
			};
		*/
		f_show_information: function(o_in)
		{
			var this_ = this;
			var private_objs = NSMessages.private_objs;
			var e_div_cgi_urlreq_information = private_objs.e_div_cgi_urlreq_information;
			
			var s_msg = o_in.s_msg;
			var i_time_out = o_in.i_time_out;
			var f_callback = o_in.f_callback;
			private_objs.f_close_callback_information = f_callback;
			
			/*
			 -> Descontinuado devido a content_security_policy sem tolerância a inline execution / CSS inline

			var o_style = o_in.o_style;
			
			if(o_style != null)
			{
				var s_style = "";
				var a_keys = Object.keys(o_style);
				for(var i=0; i<a_keys.length; i++)
				{
					var s_key_i = a_keys[i];
					var s_val_i = o_style[s_key_i];
					
					s_style += " " + s_key_i + ": " + s_val_i + ";";
					
					if(s_key_i.toLowerCase() == "width")
					{
						var i_width = parseInt(s_val_i);
						var i_half = parseInt(i_width/2)
						s_style += " left: calc(50% - " + i_half + "px);";
					}
				}

				e_div_cgi_urlreq_information.setAttribute("style", s_style);
				
			}
			*/
			
			var s_ = (s_msg != null)? s_msg : "";
			var i_time_out_ = (i_time_out != null)? i_time_out : 7500;
			
			var e_div_cgi_urlreq_information_message = private_objs.e_div_cgi_urlreq_information_message;
			e_div_cgi_urlreq_information_message.innerHTML = s_;
			e_div_cgi_urlreq_information.style.display = "inline"; //null;
			
			clearTimeout(private_objs.o_timeout_information_id);
			private_objs.o_timeout_information_id = setTimeout(function(){
				this_.f_hide_information();
				
				if(f_callback != null)
				{
					private_objs.f_close_callback_information = null;
					f_callback();
				}
			},i_time_out_);
			
		},
		f_hide_information: function()
		{
			var private_objs = NSMessages.private_objs;
			
			var e_div_cgi_urlreq_information = private_objs.e_div_cgi_urlreq_information;
			e_div_cgi_urlreq_information.style.display = "none";
		}
	
	},
	
	o_success: 
	{
		f_init_success_div: function ()
		{
			var private_objs = NSMessages.private_objs;
			var this_ = this;
			
		
			var e_div_cgi_urlreq_success = document.createElement("div");
			e_div_cgi_urlreq_success.setAttribute("id", "div_cgi_urlreq_success");
			
			e_div_cgi_urlreq_success.classList.add("message_container", "success");
			
			/*
			e_div_cgi_urlreq_success.setAttribute("style", 'position: absolute;\
												left: calc(50% - 330px);\
												width: 660px;\
												height: 108px;\
												top: 150px;\
												z-index: 1000;\
												\
												color: #222222;\
												background-color: #FFFFFF;\
												opacity: 0.96;\
												border: 1px solid #005A8B;\
												border-radius: 3px;\
												\
												\
												padding-top: 22px;\
												padding-bottom: 0px;\
												padding-left: 16px;\
												padding-right: 0px;\
												margin-bottom: 19px;\";');
			*/
												
				
			
			
			var e_div_cgi_urlreq_success_button_close = document.createElement("img");
			
			e_div_cgi_urlreq_success_button_close.setAttribute("id", "div_cgi_urlreq_success_button_close");
			e_div_cgi_urlreq_success_button_close.setAttribute("alt", "X");
			e_div_cgi_urlreq_success_button_close.setAttribute("src", private_objs.s_close_button_image_src);
			e_div_cgi_urlreq_success_button_close.setAttribute("class", "messages_close_button");
			
			
			e_div_cgi_urlreq_success_button_close.onclick = function()
			{
				clearTimeout(private_objs.o_timeout_success_id);
				this_.f_hide_success();
				
				var f_close_callback_success = private_objs.f_close_callback_success;
				if(f_close_callback_success != null)
				{
					private_objs.f_close_callback_success = null;
					f_close_callback_success();
				}
			}
			
			
			var e_div_cgi_urlreq_success_message = document.createElement("div");
			e_div_cgi_urlreq_success_message.setAttribute("id", "div_cgi_urlreq_success_message");
			
			e_div_cgi_urlreq_success.appendChild(e_div_cgi_urlreq_success_message);
			e_div_cgi_urlreq_success.appendChild(e_div_cgi_urlreq_success_button_close);
			
			private_objs.e_div_cgi_urlreq_success = e_div_cgi_urlreq_success;
			private_objs.e_div_cgi_urlreq_success_message = e_div_cgi_urlreq_success_message;
			
			this.f_hide_success();
			document.body.appendChild(e_div_cgi_urlreq_success);
		},
		
		/*
		o_in = {
			s_msg,
			i_time_out,
			f_callback,
			o_style
		}
		
		ex:
			var s_msg =	"	•	O serviço relacionado com o ID gerador GSM000111222 foi fechado.\r\n	" +
						"<br>•	Pode encontrar a informação relacionada com o serviço em questão no histórico.";
			var o_style = {
				height: "200px",
				width: "900px",
				"padding-top": "100px",
				"padding-left": "50px"
			}
			var o_in = {
				s_msg: s_msg,
				i_time_out: 750000,
				f_callback: null,
				// o_style: o_style  -> Descontinuado devido a content_security_policy sem tolerância a inline execution / CSS inline
			};
			NSMessages.f_show_success(o_in);
		*/
		f_show_success: function(o_in)
		{
			var this_ = this;
			var private_objs = NSMessages.private_objs;
			var e_div_cgi_urlreq_success = private_objs.e_div_cgi_urlreq_success;
			
			var s_msg = o_in.s_msg;
			var i_time_out = o_in.i_time_out;
			var f_callback = o_in.f_callback;
			private_objs.f_close_callback_success = f_callback;			
			

			/*
 				-> Descontinuado devido a content_security_policy sem tolerância a inline execution / CSS inline

			var o_style = o_in.o_style;
			
			if(o_style != null)
			{
				var s_style = "";
				var a_keys = Object.keys(o_style);
				for(var i=0; i<a_keys.length; i++)
				{
					var s_key_i = a_keys[i];
					var s_val_i = o_style[s_key_i];
					
					s_style += " " + s_key_i + ": " + s_val_i + ";";
					
					if(s_key_i.toLowerCase() == "width")
					{
						var i_width = parseInt(s_val_i);
						var i_half = parseInt(i_width/2)
						s_style += " left: calc(50% - " + i_half + "px);";
					}
				}

				e_div_cgi_urlreq_success.setAttribute("style", s_style);
				
			}
			*/
			
			
			var s_ = (s_msg != null)? s_msg : "";
			var i_time_out_ = (i_time_out != null)? i_time_out : 7500;
			
			var e_div_cgi_urlreq_success_message = private_objs.e_div_cgi_urlreq_success_message;
			e_div_cgi_urlreq_success_message.innerHTML = s_;
			e_div_cgi_urlreq_success.style.display = "inline"; //null;
			
			clearTimeout(private_objs.o_timeout_success_id);
			private_objs.o_timeout_success_id = setTimeout(function(){
				this_.f_hide_success();
				if(f_callback != null)
				{
					private_objs.f_close_callback_success = null;
					f_callback();
				}
			},i_time_out_);
			
		},
		f_hide_success: function()
		{
			var private_objs = NSMessages.private_objs;
			
			var e_div_cgi_urlreq_success = private_objs.e_div_cgi_urlreq_success;
			e_div_cgi_urlreq_success.style.display = "none";
		}
	
	}




	/*
	//Object to return...
	var NSMessages = {
		init: init,
		f_show_error: f_show_error,
		f_hide_error: f_hide_error,
		f_show_information: f_show_information,
		f_hide_information: f_hide_information,
		f_show_success: f_show_success,
		f_hide_success: f_hide_success

	}
	*/
	
}

/*
window.addEventListener("load", function(){
	NSMessages.init();
	});
*/